module.exports = __webpack_public_path__ + "media/images/favicon-4f3bdb9b86cb8bc4ed30206b74b229de.ico";